import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
const UpdateFuelCategory = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // Form fields
  const [stationID, setstationID] = useState("");
  const [categoryName, setcategoryName] = useState("");
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      var data = props.data;
      setstationID(data.station_id || "");
      setcategoryName(data.fuel_category || "");
    }
  }, [props.data]);
  const allRowsFilled = () => categoryName && stationID;
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      station_id: stationID,
      fuel_category: categoryName,
    };
    setLoading(true);
    const response = await ajaxFuelCategories.update_fuel_category(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      setTimeout(() => {
        closeModal();
      }, 2000);
    } else {
      toast.error(response.message);
      setLoading(false);
    }
  };
  const [stations_list, setstations_list] = useState([]);
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.station_name,
        }));
      setstations_list(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update Farm"}
      </button>
    </>
  );
  return (
    <SystemModal title="Update Fuel category" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <form>
                  <div className="row mb-3">
                    {/* Owner */}
                    <div className="col-md-12">
                      <label>
                        select Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations_list}
                        value={
                          stations_list.find(
                            (item) => item.value === stationID
                          ) || null
                        }
                        isDisabled={true}
                        onChange={(selected) => setstationID(selected.value)}
                        placeholder="Select station group"
                      />
                    </div>
                    {/* Station Name */}
                    <div className="col-md-12">
                      <label>
                        Fuel Category name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={categoryName}
                        onChange={(e) => setcategoryName(e.target.value)}
                        className="form-control"
                        placeholder="Fuel category  name e.g petro, diesel"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateFuelCategory;
